module.exports = __webpack_public_path__ + "static/media/CT_2019_30444_3901_pdf.c1bf0a21.pdf";